





import {Component, Prop, Provide, Vue, Watch} from 'vue-property-decorator';

export type TextLookup = (s: string, p?: {[key: string]: string}) => string;

/**
 * Compatibility layer for vue-i18n compatibility with old components.
 *
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component({})
export default class JdsTextProvider extends Vue {
    @Provide('jds.text') textProvider: TextLookup = (s: string) => s;

    @Prop({default: () => (key: string) => key}) lookup!: TextLookup;

    @Watch('lookup', {immediate: true})
    syncProvide() {
        this.textProvider = this.lookup;
    }
}
